import React from "react";
import styled from "styled-components";
import { firebaseConnect } from "react-redux-firebase";
import { compose } from "redux";
import { connect } from "react-redux";

import Loading from "./Loading";
import Form from "./Form";
import ConfirmationDialog from "./ConfirmationDialog";

const Header = styled.header`
  padding: 1em 3em;
  background-image: linear-gradient(#eca611, #fdc823);
  display: grid;
  grid-template-columns: 70px auto 160px;
  grid-auto-flow: row;
  justify-items: center;
  grid-column-gap: 1em;
  @media screen and (max-width: 500px) {
    & {
      padding: 1em;
    }
  }
`;

const Name = styled.h2`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  justify-self: stretch;
  @media screen and (max-width: 500px) {
    & {
      display: none;
    }
  }
`;

const Avatar = styled.img`
  height: 68px;
  border-radius: 50%;
`;

const Logout = styled.button`
  align-self: center;
  background-color: #795548;
  border: none;
  padding: 1em 3em;
  border-radius: 2px;
  font-size: 1em;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  color: #fff;
  white-space: nowrap;
  grid-column: 3/4;
`;

const Content = styled.section`
  padding: 1em 3em;
  flex: 1 0 auto;
`;

const Watches = styled.ul`
  display: flex;
  flex-direction: column;
  list-style-type: none;
  padding: 0;
`;

const Watch = styled.li`
  padding: 1em 1em 1em 3em;
  display: grid;
  grid-template-columns: auto 200px 26px;
  grid-auto-flow: row;
  grid-column-gap: 1em;
  grid-row-gap: 0.5em;
  justify-items: flex-start;
  align-items: center;
  &:nth-child(1n) {
    background-color: #232323;
  }
  &:nth-child(2n) {
    background-color: #323232;
  }
  & .name {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    justify-self: stretch;
  }
  & .LEI {
    font-family: monospace;
    font-size: 1.2em;
    color: rgba(255, 255, 255, 0.5);
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    justify-self: stretch;
  }
  & .remove {
    cursor: pointer;
  }
  @media screen and (max-width: 500px) {
    & {
      padding: 1em;
      grid-template-columns: auto 26px;
    }
    & .remove {
      grid-row: 1/3;
      grid-column: 2/3;
    }
  }
`;

class Dashboard extends React.PureComponent {
  state = {
    removeWatch: null
  };

  LEIExists = LEI =>
    this.props.watches.reduce((any, watch) => any || watch.LEI === LEI, false);

  onSubmit = company =>
    this.props.firebase.push(`watches/${this.props.auth.uid}`, company);
  onRemove = watch => () => {
    this.setState({ removeWatch: watch });
  };
  onConfirm = result => {
    this.setState({ removeWatch: null });
    if (!result) return;
    this.props.firebase.remove(
      `watches/${this.props.auth.uid}/${this.state.removeWatch.key}`
    );
  };

  render() {
    const { firebase, auth, watches } = this.props;
    return (
      <React.Fragment>
        <Header>
          <Avatar src={auth.photoURL} alt={auth.displayName} />
          <Name>{auth.displayName}</Name>
          <Logout onClick={firebase.logout}>Logga ut</Logout>
        </Header>
        <Content>
          <p>
            Här ser du en lista över de företag som du har satt under bevakning.
          </p>
          {!watches && <Loading small />}
          {watches &&
            watches.length === 0 && (
              <p>Du har inga företag under bevakning ännu.</p>
            )}
          {watches && (
            <Watches>
              {watches.map(watch => (
                <Watch key={watch.key}>
                  <span className="name">{watch.name}</span>
                  <span className="LEI">{watch.LEI}</span>
                  <span
                    className="remove"
                    onClick={this.onRemove(watch)}
                    role="img"
                    aria-label="Ta bort bevakning"
                  >
                    ❌
                  </span>
                </Watch>
              ))}
            </Watches>
          )}
        </Content>
        {this.state.removeWatch && (
          <ConfirmationDialog
            onConfirm={this.onConfirm}
            watch={this.state.removeWatch}
          />
        )}
        <Form onSubmit={this.onSubmit} LEIExists={this.LEIExists} />
      </React.Fragment>
    );
  }
}

export default compose(
  firebaseConnect((_, store) => [
    `watches/${store.getState().firebase.auth.uid}`
  ]),
  connect(({ firebase }) => {
    const auth = firebase.auth;
    const watches = firebase.data.watches
      ? firebase.data.watches[auth.uid]
        ? Object.entries(firebase.data.watches[auth.uid]).map(([key, val]) => {
            val.key = key;
            return val;
          })
        : []
      : null;
    return {
      auth,
      watches
    };
  })
)(Dashboard);



// WEBPACK FOOTER //
// ./src/Dashboard.js